<template>
  <div class="card">
    <div class="card-header">
      <span class="font-weight-bold">Suivi de planification</span>

      <label
        class="switch switch-sm switch-text switch-info ml-1 float-right mb-0 mr-0"
      >
        <input
          v-model="enabled"
          type="checkbox"
          class="switch-input"
          @change="toggleSessionScheduleTracking"
        />

        <span class="switch-label" data-on="On" data-off="Off"></span>

        <span class="switch-handle"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      enabled: false,
    };
  },

  mounted() {
    this.enabled = this.order.sessionScheduleTracking;
  },

  methods: {
    async toggleSessionScheduleTracking() {
      try {
        await this.$api.put(`/orders/${this.order.id}`, {
          sessionScheduleTracking: this.enabled,
        });
      } catch (e) {
        this.$errorToast(
          `Impossible ${
            this.enabled ? `d'activer` : "de désactiver"
          } le suivi de planification de séances`,
        );

        this.enabled = !this.enabled;
      }

      this.$emit("update", this.enabled);
    },
  },
};
</script>
